import { useRef } from 'react';

/**
 * Rows stay where they are once you act on the page (Sam, 2026-10-28: Join on an event and it snapped up into Trending,
 * because the refetch after an RSVP re-ranks by popularity). While `locked`, every section keeps the rows and order it
 * had, with each row's latest data (counts, your status); a row that left the data stays as last seen; rows that are new
 * (the next page loading) join the end of the section they arrived in. Unlocked, it passes the sections through and
 * remembers them. Same idea as the map chips that stopped reordering under the finger (FestivalMap).
 */
export function useStayPut(sections, locked, keyOf = (row) => row.event_id) {
  const snap = useRef(null);
  if (!locked || !snap.current) {
    snap.current = {
      ids: sections.map((rows) => rows.map(keyOf)),
      rows: new Map(sections.flat().map((r) => [keyOf(r), r])),
    };
    return sections;
  }
  const { ids, rows } = snap.current;
  for (const r of sections.flat()) rows.set(keyOf(r), r); // latest data for rows already placed
  const placed = new Set(ids.flat());
  sections.forEach((section, i) => {
    for (const r of section) {
      const k = keyOf(r);
      if (!placed.has(k)) {
        ids[i].push(k);
        placed.add(k);
      }
    }
  });
  return ids.map((list) => list.map((k) => rows.get(k)).filter(Boolean));
}
